/**
 * 链上补全 name / symbol / metaURI→image（对齐经典 monitor.js）
 * RPC 走同源 /api/rpc.php，IPFS JSON 走 /api/ipfs.php
 */
const META_URI_SEL = "0x67605787"; // metaURI()
const NAME_SEL = "0x06fdde03";
const SYMBOL_SEL = "0x95d89b41";

function sleep(ms) {
  return new Promise((r) => setTimeout(r, ms));
}

function decodeAbiString(hex) {
  if (!hex || hex === "0x" || hex.length < 130) return "";
  try {
    const offset = parseInt(hex.slice(2, 66), 16);
    const start = 2 + offset * 2;
    const len = parseInt(hex.slice(start, start + 64), 16);
    if (!len || len > 256) return "";
    const data = hex.slice(start + 64, start + 64 + len * 2);
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = parseInt(data.slice(i * 2, i * 2 + 2), 16);
    }
    return new TextDecoder("utf-8").decode(bytes).replace(/\0+$/, "").trim();
  } catch {
    return "";
  }
}

async function rpcCall(to, data) {
  const res = await fetch("/api/rpc.php", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      jsonrpc: "2.0",
      id: 1,
      method: "eth_call",
      params: [{ to, data }, "latest"],
    }),
    signal: AbortSignal.timeout(8000),
  });
  const json = await res.json();
  if (json.error) throw new Error(json.error.message || "rpc error");
  return json.result || "0x";
}

function normalizeImage(img) {
  const s = String(img || "").trim();
  if (!s) return "";
  if (/^https?:\/\//i.test(s)) return s;
  const cid = s
    .replace(/^ipfs:\/\//i, "")
    .replace(/^\/ipfs\//i, "")
    .split(/[/?#]/)[0];
  if (!cid) return "";
  return "https://flap.mypinata.cloud/ipfs/" + cid;
}

/** @returns {Promise<{name:string,symbol:string,image:string,meta:string}>} */
export async function fetchTokenMeta(addr) {
  const token = String(addr || "").toLowerCase();
  const out = { name: "", symbol: "", image: "", meta: "" };
  if (!/^0x[a-f0-9]{40}$/.test(token)) return out;
  try {
    out.name = decodeAbiString(await rpcCall(token, NAME_SEL));
    await sleep(60);
    out.symbol = decodeAbiString(await rpcCall(token, SYMBOL_SEL));
    await sleep(60);
    const metaRaw = decodeAbiString(await rpcCall(token, META_URI_SEL));
    const cid = metaRaw
      .replace(/^ipfs:\/\//i, "")
      .replace(/^\/ipfs\//i, "")
      .split(/[/?#]/)[0];
    if (cid && /^(bafy|bafk|Qm)[a-zA-Z0-9]+$/i.test(cid)) {
      out.meta = cid;
      const res = await fetch("/api/ipfs.php?cid=" + encodeURIComponent(cid), {
        signal: AbortSignal.timeout(6000),
      });
      if (res.ok) {
        const j = await res.json();
        if (j?.image) out.image = normalizeImage(j.image);
        if (!out.name && j?.name) out.name = String(j.name);
        if (!out.symbol && j?.symbol) out.symbol = String(j.symbol);
      }
    }
  } catch {
    /* ignore */
  }
  return out;
}

export function needsMeta(row) {
  if (!row) return false;
  const name = String(row.name || "").trim();
  const symbol = String(row.symbol || "").trim();
  const image = String(row.image || "").trim();
  return !(name && symbol && image);
}
